import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { ICustomColumn } from '../../../../../../common/types/commonTypes';
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks';
import {
  fitterReturnsFiltersSelector,
  reportIsVisibleSelector,
} from '../../../../../../store/selectors/reportsSelectors';
import Tr from '../../../../../../core/components/table-components/Tr';
import ThWithControls from '../../../../../../core/components/table-components/ThWithControls';
import ThNew from '../../../../../../core/components/table-components/table-new/ThNew';
import Dropdown from '../../../../../../core/components/dropdown/Dropdown';
import Thead from '../../../../../../core/components/table-components/Thead';
import { SearchTableFilterType } from '../../../../../../core/types/coreTypes';
import {
  setFitterReturnsReportFilters,
} from '../../../../../../store/slices/reportsSlice';
import {
  getPurchasingFitterReturnsReportExcelThunk,
  getPurchasingFitterReturnsReportThunk,
} from '../../../../../../store/thunks/reports/reportsThunks';

type FitterReturnsColumnsProps = {
  columns: ICustomColumn[],
  totalCount: number,
}

const FitterReturnsColumns: React.FC<FitterReturnsColumnsProps> = ({ totalCount, columns }) => {
  const dispatch = useAppDispatch();
  const reportIsVisible = useAppSelector(reportIsVisibleSelector);
  const filters = useAppSelector(fitterReturnsFiltersSelector);

  const [searchVl, setSearchVl] = useState<SearchTableFilterType>({
    partCode: filters.partCode,
    partName: filters.partName,
  });

  useEffect(() => {
    if (!reportIsVisible) {
      setSearchVl({
        partCode: undefined,
        partName: undefined,
      });
    }
  }, [reportIsVisible]);

  const sortHandle = (field: number) => {
    if (filters.order?.field === field) {
      const newFilters = {
        ...filters,
        order: { ...filters.order, isAsc: !filters.order.isAsc },
      };
      dispatch(setFitterReturnsReportFilters(newFilters));
      dispatch(getPurchasingFitterReturnsReportThunk({ filters: newFilters }));
    } else {
      const newFilters = {
        ...filters,
        order: { field, isAsc: true },
      };
      dispatch(setFitterReturnsReportFilters(newFilters));
      dispatch(getPurchasingFitterReturnsReportThunk({ filters: newFilters }));
    }
  };

  const onChangeSearchHandle = (v: string, field: string) => {
    setSearchVl({ ...searchVl, [field]: v });
    if (!v) {
      const newFilters = { ...filters, [field]: undefined, page: 1 };
      dispatch(setFitterReturnsReportFilters(newFilters));
      dispatch(getPurchasingFitterReturnsReportThunk({ filters: newFilters }));
    }
  };
  const searchPressHandle = (field: string) => {
    const newFilters = { ...filters, [field]: searchVl[field]?.trim(), page: 1 };
    dispatch(setFitterReturnsReportFilters(newFilters));
    dispatch(getPurchasingFitterReturnsReportThunk({ filters: newFilters }));
  };

  const exportToExcel = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { page, pageSize, ...rest } = filters;
    dispatch(getPurchasingFitterReturnsReportExcelThunk({ filters: rest }));
  };
  return (
    <Thead>
      <Tr>
        {columns.map((col) => (
          <ThWithControls
            key={col.dataIndex}
            col={col}
            tableFilters={filters}
            sortHandle={sortHandle}
            onChangeSearchHandle={onChangeSearchHandle}
            searchPressHandle={searchPressHandle}
            searchVl={searchVl}
            totalElements={totalCount}
            className={`fitterReturnsTh--${col.dataIndex}`}
            disabledFilter={!reportIsVisible}
          />
        ))}
        <ThNew action>
          <Dropdown
            disabled={!totalCount}
            menuItems={[
              {
                label: 'Export to Excel',
                icon: <FontAwesomeIcon icon={faFileExcel} />,
                key: 'export-to-excel',
                onClick: exportToExcel,
              },
            ]}
            icon={<FontAwesomeIcon icon={faGear} />}
          />
        </ThNew>
      </Tr>
    </Thead>
  );
};

export default FitterReturnsColumns;
